import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import './Toggle.scss';

interface ToggleProps {
    onClick: (arg0: boolean) => void;
    renderDisplayValue: (arg0: boolean) => void;
    isActive: boolean;
    shouldNotOptimisticUpdate: boolean;
}

export const Toggle: React.FunctionComponent<ToggleProps> = (props) => {
    const [isActive, setActive] = useState(props.isActive);

    useEffect(() => {
        setActive(props.isActive);
    }, [props.isActive]);

    const handleClick = () => {
        props.onClick(!isActive);

        if (!props.shouldNotOptimisticUpdate) {
            setActive(!isActive);
        }
    };

    const classes = classnames('toggle', {
        'toggle--active': isActive,
        'toggle--inactive': !isActive,
    });

    return (
        <button className={classes} onClick={handleClick}>
            <div className="toggle__outline" />
            {props.renderDisplayValue(isActive)}
        </button>
    );
};
